import React from 'react';
import styled from 'styled-components';
import { crossScreenFontSize, crossScreenMarginBottom, link, linkChangeColor } from '../../../utils/styles';

const RU = 'ru';
const EN = 'en';

const Styled = styled.div`
  ${crossScreenMarginBottom(160)};
`;

const Item = styled.div`
  ${crossScreenMarginBottom(5)};

  &:last-child {
    margin-bottom: 0;
  }
`;

const Link = styled.a`
  ${crossScreenFontSize(40)};
  ${link};
  ${props => linkChangeColor(props.theme.colorText)};
  ${props =>
    props.current &&
    css`
      pointer-events: none;
      color: ${props.theme.colorMinor};
    `};
`;

class LangSwitcher extends React.Component {
  state = {
    currentLang: null,
    languages: [
      {
        displayName: 'Ru',
        id: RU,
      },
      {
        displayName: 'Eng',
        id: EN,
      },
    ],
  };

  componentDidMount() {
    this.detectLang();
  }

  detectLang() {
    const siteLang = /^\/ru(\/?|(\?.*)?)/.test(location.pathname) ? RU : EN;
    this.setState({ currentLang: siteLang });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentLang !== this.state.currentLang) {
      const storedLang = localStorage.getItem('lang');
      if (storedLang) {
        return;
      }

      // TODO: включить, когда будут настроены языки на бэке
      // let browserLang = window.navigator.language || window.navigator.systemLanguage || window.navigator.userLanguage;
      // browserLang = browserLang === 'ru-RU' || browserLang === RU ? RU : EN;
      //
      // if (browserLang !== this.state.currentLang) {
      //   this.redirectToLang(browserLang);
      // }
    }
  }

  redirectToLang(lang) {
    if (lang === RU) {
      location.href = `/ru${location.pathname}`;
    } else {
      location.href = location.pathname.replace(/^\/ru/, '') || '/';
    }
  }

  handleLinkClick = (e, lang) => {
    e.preventDefault();
    this.redirectToLang(lang);
    localStorage.setItem('lang', lang);
  };

  render() {
    return (
      <Styled>
        {this.state.languages.map((l, index) => (
          <Item key={index}>
            <Link
              href={`/${l.id}/`}
              current={l.id === this.state.currentLang}
              onClick={e => this.handleLinkClick(e, l.id)}
            >
              {l.displayName}
            </Link>
          </Item>
        ))}
      </Styled>
    );
  }
}

export default LangSwitcher;



// WEBPACK FOOTER //
// ./src/components/Header/components/LangSwitcher.js